(function () {
  'use strict';
  document.addEventListener('DOMContentLoaded', init);
  if (document.readyState === 'complete' || document.readyState === 'interactive') { init(); }
  var didInit = false;
  function init() {
    if (didInit) return;
    didInit = true;
    initMoodPills();
    initHoverVideoCards();
  }

  function initMoodPills() {
    var pillsWrap = document.querySelector('[data-mood-pills]');
    var grid = document.querySelector('[data-mood-grid]');
    if (!pillsWrap || !grid) return;
    var pills = Array.prototype.slice.call(pillsWrap.querySelectorAll('.mood-pill'));
    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-mood-card]'));

    grid.setAttribute('data-active-mood', 'all');

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        var mood = pill.getAttribute('data-mood');
        pills.forEach(function (p) {
          p.classList.toggle('is-active', p === pill);
          p.setAttribute('aria-pressed', p === pill ? 'true' : 'false');
        });
        grid.setAttribute('data-active-mood', mood);
        cards.forEach(function (card) {
          card.classList.remove('is-match', 'is-dim');
          if (mood === 'all') return;
          var moods = (card.getAttribute('data-moods') || '').split(' ');
          if (moods.indexOf(mood) !== -1) {
            card.classList.add('is-match');
          } else {
            card.classList.add('is-dim');
          }
        });
      });
    });
  }

  // Hover/focus-to-play video on collection cards. Only touches cards that
  // opted in via data-cg-video-card (i.e. the collection has a
  // custom.origin_video metafield) — today that's the Characters grid.
  // Every other card on the page has no [data-cg-video] element and is
  // completely unaffected by this code.
  function initHoverVideoCards() {
    var cards = document.querySelectorAll('[data-cg-video-card]');
    if (!cards.length) return;
    cards.forEach(function (card) {
      var video = card.querySelector('[data-cg-video]');
      if (!video) return;
      var play = function () {
        card.classList.add('is-playing');
        video.currentTime = 0;
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      };
      var stop = function () {
        card.classList.remove('is-playing');
        video.pause();
      };
      card.addEventListener('mouseenter', play);
      card.addEventListener('mouseleave', stop);
      card.addEventListener('focus', play);
      card.addEventListener('blur', stop);
      card.addEventListener('touchstart', play, { passive: true });
    });
  }
})();
